/**
 * Keycloak realm roles (arqam): reader < treasurer / committee. A user can
 * hold both treasurer and committee. The API enforces them; the apps only use
 * them to hide what a user can't do.
 */
export const ROLES = ['reader', 'treasurer', 'committee'] as const;
export type Role = (typeof ROLES)[number];

type TokenClaims = { realm_access?: { roles?: string[] } } | undefined;

export function rolesFromToken(claims: TokenClaims): Role[] {
  const granted = claims?.realm_access?.roles ?? [];
  return ROLES.filter((role) => granted.includes(role));
}

/** True if the user holds at least one of `allowed`. */
export const hasAnyRole = (roles: Role[], allowed: readonly Role[]) =>
  allowed.some((role) => roles.includes(role));
